import {STORE_ADMIN_REQUEST, STORE_ADMIN_SUCCESS, STORE_ADMIN_FAILURE} from '../actions';
import {UPDATE_ADMIN_REQUEST, UPDATE_ADMIN_SUCCESS, UPDATE_ADMIN_FAILURE} from '../actions';

export const ADMIN_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    name: '',
    branch_location: null,
    job_title: '',
    phone_number: '',
    email: '',
    permissions: []
};

const adminReducers = {
    [STORE_ADMIN_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_ADMIN_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [STORE_ADMIN_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_ADMIN_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_ADMIN_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [UPDATE_ADMIN_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    }
};

export default function admin(state = ADMIN_INITIAL_STATE, action) {
    let reducer = adminReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/admin.js